import {UseFormReturn} from 'react-hook-form';

import {BaseVehicle} from '../../types/BaseVehicle';

export interface FormUpdateFeaturesActionParams {
  form: UseFormReturn<BaseVehicle>;
  features: string[];
}

/**
 * XState action for updating vehicle features from autofill
 * Updates the features field in the form
 *
 * @param _context - XState context (unused)
 * @param params - Parameters containing form instance and features data
 */
export const formUpdateFeaturesAction = (
  _context: unknown,
  params: FormUpdateFeaturesActionParams
): void => {
  const {form, features} = params;

  form.setValue('features', features, {
    shouldDirty: true,
    shouldValidate: true,
  });
};
